// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_jh7Gl","footer2":"index_footer2_YMbzl"};